// Inhalte der Sektionen gleiten beim Scrollen von unten ein (wie bernergesundheit.ch).
// Die Klasse «reveal» setzt das Inline-Script im <head>, damit nichts aufblitzt.
export function initReveal() {
  const root = document.documentElement
  if (!root.classList.contains("reveal")) return

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-revealed")
        observer.unobserve(entry.target)
      }
    }
  })
  for (const el of document.querySelectorAll(
    ":is(.section, .quote) > .container > *",
  )) {
    observer.observe(el)
  }
  root.classList.add("reveal-ready")
}
